// extracted by mini-css-extract-plugin
export default {"container":"OpenEndTextarea_container__fYHcD","textareaLittle":"OpenEndTextarea_textareaLittle__zWjTp"};